import { omitBy } from 'lodash'
import queryString from 'query-string'

import type { FormValue } from '../ui/Form'

/**
 * Creator: value or function which returns value
 */
export type Creator<T> = T | (() => T)

/**
 * Updater: value or function which returns value
 */
export type Updater<T> = T | ((value: T) => T)

/**
 * Shallow compare of two nullable values
 * @param value1
 * @param value2
 * @param isEqual
 */
export function isEqualNullables<TValue = unknown>(
  value1: Nullable<TValue> = null,
  value2: Nullable<TValue> = null,
  isEqual: (value1: TValue, value2: TValue) => boolean
) {
  return (
    (value1 === null && value2 === null) ||
    (value1 !== null && value2 !== null && isEqual(value1, value2))
  )
}

export function toSearchString(params?: object | null): string {
  return queryString.stringify(omitBy(params, (v) => v == null || v === ''))
}

export const convertFormValueToString = (value: FormValue): string => {
  if (typeof value === 'string') {
    return value
  } else if (value instanceof Date) {
    return value.toISOString()
  } else if (value !== null && value !== undefined) {
    return value.toString()
  }

  return ''
}
